import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
export default class MeetingHistoryExportTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Meeting History Export';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.ANALYTICS.MEETING_HISTORY_EXPORT, ($e, data) => {
            this.trackButtonEventSegment(data);
        });
    }
}
